import ItemMovimentacaoModel from "@/models/cliente/item-movimentacao.model";

class MovimentacaoRequest {

    itens: ItemMovimentacaoModel[];

    constructor() {
        this.itens = [];
    }

}

export default MovimentacaoRequest;
